import React from 'react'
import { toast } from 'react-toastify'
import { Cancel, CheckCircle } from '@mui/icons-material'

export const Toast = {
  success: msg => toast.success(msg, { icon: <CheckCircle style={{ color: '#61d345' }} /> }),
  error: msg => toast.error(msg, { icon: <Cancel style={{ color: '#ff4b4b' }} /> }),
}
